module.exports = __webpack_public_path__ + "809e089df648d5ec732d293f6cc4ded3.png";